/* eslint-disable prefer-regex-literals */

/**
 * Szöveg trimmelése csak az elején.
 * @param {string} str - A szöveg.
 * @param {string} [chr] - A karakter, amit trimmelni szeretnénk.
 * @returns {string} A trimmelt szöveg.
 */
module.exports.ltrim = function ltrim (str, chr) {
  const rgxtrim = (chr) ? new RegExp(`^${ chr }+`) : new RegExp('^\\s+')

  return str.replace(rgxtrim, '')
}
